// Collect + group for the projection lens, on the factory's layers.
import { extractProjectionOps } from "./index.js";
import { collectWindowOps, groupActivity, distinctKey } from "../../src/build/index.js";

export const extract = extractProjectionOps;

// A later sighting knows more when it captured the answer. Bodies are cumulative,
// so a projection is first seen before its result was recorded.
export const informedness = (op) => (op.rows || 0) * 100 + (op.output?.length || 0);
export const collect = (prompts) => collectWindowOps(prompts, { informedness });

// The unit a reader sees is the ARTIFACT being queried — the piece of state whose
// truth is in question. A projection over several artifacts keys on the set.
export const groupBy = (op) => (op.artifacts?.length
  ? op.artifacts.slice().sort().join(" + ")
  : distinctKey("unnamed artifact", op));

export const build = (flat) => groupActivity(flat, {
  key: groupBy,
  label: (op) => (op.artifacts?.length ? op.artifacts.slice().sort().join(" + ") : `${op.shape} projection`),
  seed: () => ({ kinds: {}, labels: [], filters: [], raised: 0, keys: [], origins: {} }),
  fold: (g, op) => {
    g.kinds[op.shape] = (g.kinds[op.shape] || 0) + 1;
    g.origins[op.origin] = (g.origins[op.origin] || 0) + 1;
    if (op.raised) g.raised += 1;
    // The union of keys read across every query of this artifact: what the session
    // actually cared about in it.
    for (const k of op.projection || []) if (!g.keys.includes(k)) g.keys.push(k);
    for (const f of op.filters || []) if (!g.filters.includes(f)) g.filters.push(f);
  },
});

export const anchor = () => "json.load";
export const ignore = ["output", "program"];
